import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Sin protocolo de intervención',
    cost: 'Quedás expuesto cuando el campo se detiene'
  }, {
    without: 'Sin seguimiento documentado',
    cost: 'Cada sesión sin continuidad ni hilo conductor'
  }, {
    without: 'Sin frases sanadoras clasificadas',
    cost: 'Improvisás las palabras más importantes del proceso'
  }, {
    without: 'Sin ficha clínica profesional',
    cost: 'Procesos sin registro que no generan confianza'
  }, {
    without: 'Sin Maestría en Consulta',
    cost: 'Seguís esperando que la profundidad llegue sola'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de improvisación, la próxima semana'
  }];
  return <Section data-id="element-16">
      <div className="text-center mb-12" data-id="element-17"></div>

      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="hidden md:block" data-id="element-19">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-20">
            <div className="font-serif font-bold text-lg text-brand-violet" data-id="element-21">
              Sin Kit Constelaciones
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-22">
              Costo Real
            </div>
          </div>
          <div className="space-y-3" data-id="element-23">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-24">
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-25">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-26">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>
      </div>

      <div className="text-center mt-10" data-id="element-27">
        <p className="text-lg md:text-2xl font-display italic font-[600] text-brand-violetDark" data-id="element-28">
          "El terapeuta que tiene un sistema, trabaja con confianza. El que
          trabaja con confianza, genera resultados. El que genera resultados,
          crece." 🌿
        </p>
      </div>
    </Section>;
};